/* eslint-disable react-hooks/exhaustive-deps */
import { useParams } from "react-router-dom";
import InstituteOfChargeDetail from "./InstituteOfChargeDetail";

const InstituteOfChargeDetailFromSidebar = () => {
  const params = useParams();
  const { caseId } = params;

  return <InstituteOfChargeDetail caseId={caseId as string} />;
};

export default InstituteOfChargeDetailFromSidebar;
